import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { RequestService } from './request.service';
import { URLSearchParams } from '@angular/http';
import { PageTemplate, OfferTemplate } from '@app/shared';


@Injectable()
export class StudioService implements RequestService {


  redirectUrl: String = "";
  isBusy = false;
  private serviceUrl = 'studio';  // URL to web api

  constructor(
    private http: HttpClient,
    ) { }


    // document sub types
    getPageBackgrounds(): Observable<any> {

      let project = window.location.href;
      const regex = /project=.*?[^&]+/g;
      let uuid = String(project.match(regex));
      uuid = uuid.substring('project='.length);

      // const url = `${environment.baseURL}pagebackground/all`;
      const url = `${environment.baseURL}pagebackground/all?campaignUUID=${uuid}`;

      let httpParams = new HttpParams();
      let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

      return this.http.get<any>(url,{
         //params : httpParams
         headers: headers
      })

    }

    // Page templates
    getPageTemplates(): Observable<any> {

      let project = window.location.href;
      const regex = /project=.*?[^&]+/g;
      let uuid = String(project.match(regex));
      uuid = uuid.substring('project='.length);

      // const url = `${environment.baseURL}template/page`;
      const url = `${environment.baseURL}template/page?campaignUUID=${uuid}`;

      let httpParams = new HttpParams();
      let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

      return this.http.get<any>(url,{
         //params : httpParams
         headers: headers
      })

    }

    // Offer templates
    getOfferTemplates(): Observable<any> {

      let project = window.location.href;
      const regex = /project=.*?[^&]+/g;
      let uuid = String(project.match(regex));
      uuid = uuid.substring('project='.length);
      
      // const url = `${environment.baseURL}template/offer?include=offertype`;
      const url = `${environment.baseURL}template/offer?include=offertype&campaignUUID=${uuid}`;

      let httpParams = new HttpParams();
      let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

      return this.http.get<any>(url,{
         //params : httpParams
         headers: headers
      })

    }


        // Offer templates
    checkFileExists(url:string): Observable<any> {
      const uri = url;
      return this.http.head(uri)
    }

    assignPageTemplate(pageUUID:string,templateUUID:string): Observable<any> {
      const url = `${environment.baseURL}page/assign`;

      let httpParams = new HttpParams();
      let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

      let urlSearchParams = new URLSearchParams();
      urlSearchParams.append('pageUUID',pageUUID);
      urlSearchParams.append('templateUUID',templateUUID);
      let bodyParams = urlSearchParams.toString();

      return this.http.post<PageTemplate>(url,bodyParams,{
         //params : httpParams
         headers: headers
      })

    }


    assignOfferTemplate(offerTemplateUUID:string,offerUUID:string): Observable<any> {
      const url = `${environment.baseURL}offer/assign/template`;

      let httpParams = new HttpParams();
      let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

      let urlSearchParams = new URLSearchParams();
      urlSearchParams.append('offerTemplateUUID',offerTemplateUUID);
      urlSearchParams.append('offerUUID',offerUUID);
      let bodyParams = urlSearchParams.toString();

      return this.http.post<OfferTemplate>(url,bodyParams,{
         //params : httpParams
         headers: headers
      })

    }
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better Studio of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.

      return of(result as T);
    };
  }
  /** Log a UserService message with the MessageService */
  private log(message: string) {
    //this.messageService.add('UserService: ' + message);
  }



}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/studio.service.ts